<template>
  <div class="choose-users-page" data-test="choose-user__page">
    <Card
      class="shop-users-card">
      <el-collapse-transition>
        <div class="shop-users-card__header" v-loading="loading" v-if="!selectedUser">
          <UserItem
            v-for="user in users"
            :key="user.id"
            :displayName="user.displayName"
            :title="user.displayTitle"
            @onClick="handleChooseUserToLogin(user)"/>
        </div>
      </el-collapse-transition>
      <el-collapse-transition>
        <div class="shop-users-card__header" v-if="selectedUser">
          <el-button
            size="mini"
            icon="el-icon-arrow-left"
            @click="resetUser">
            Retour
          </el-button>
          <div class="shop-users-card__login-form">
            <div style="text-align: center; color: #6f6f6f; margin-bottom: 20px; margin-top: 20px;">
              <div>Ravi de vous revoir <strong>{{ selectedUser.firstname }}</strong> !</div>
              <div>Utilisez votre mot de passe pour vous connecter.</div>
            </div>
            <LoginForm
              v-loading="connecting"
              :disabled="displayForgotPassword"
              @onLogin="handleLogin"
              @forgotPassword="toggleForgotPassword"
            />
            <el-collapse-transition>
              <ForgotPasswordForm
                v-loading="resetingPassword"
                v-if="displayForgotPassword"
                @submited="confirmAndProceedResetPassword"
                @canceled="toggleForgotPassword"
              />
            </el-collapse-transition>
          </div>
        </div>
      </el-collapse-transition>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import UserItem from '@/views/pages/UserLoginPage/UserItem.vue';
import LoginForm from '@/views/pages/UserLoginPage/LoginForm.vue';
import ForgotPasswordForm from '@/views/pages/UserLoginPage/ForgotPasswordForm.vue';
import services from 'services';
import _ from 'lodash';

export default {
  components: {
    Card,
    UserItem,
    LoginForm,
    ForgotPasswordForm,
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      users: [],
      selectedUser: null,
      displayForgotPassword: false,
      resetingPassword: false,
      connecting: false,
    };
  },
  methods: {
    async fetchData() {
      this.users = await services.shopAuthService.listAllUsers();
    },
    resetSelectedUser() {
      this.selectedUser = null;
    },
    handleChooseUserToLogin(user) {
      this.selectedUser = user;
    },
    async handleLogin({ password }) {
      this.connecting = true;
      try {
        this.$mixpanel.track('Connexion utilisateur', { email: this.selectedUser.email });
        await this.$store.dispatch('auth/loginWithCredentials', {
          email: this.selectedUser.email,
          password,
        });
        this.$router.push({ name: 'Profile' });
      } catch (e) {
        this.$mixpanel.track('Echec connexion utilisateur', { code: _.get(e, 'code') });
        if (_.get(e, 'code') === 'auth/user-disabled') {
          this.showErrorMessage(this.$t('loginPage.errorAccountDisabled'));
        } else if (_.get(e, 'code') === 'auth/wrong-password') {
          this.showErrorMessage(this.$t('loginPage.errorWrongPassword'));
        } else {
          this.showErrorMessage(this.$t('commons.defaultErrorMessage'));
        }
      }
      this.connecting = false;
    },
    toggleForgotPassword() {
      this.displayForgotPassword = !this.displayForgotPassword;
    },
    showResetPasswordSuccessMessage() {
      this.$message.success(this.$t('resetPasswordForm.requestSentForApproval'));
    },
    showErrorMessage(message) {
      this.$message.error({ message });
    },
    async confirmAndProceedResetPassword({ password }) {
      this.$confirm(
        this.$t('resetPasswordForm.confirmMessageText'),
        this.$t('resetPasswordForm.confirmBoxTitle'),
        {
          confirmButtonText: this.$t('resetPasswordForm.confirmBoxButtonContinue'),
          confirmButtonClass: 'el-button el-button--danger',
          cancelButtonText: this.$t('resetPasswordForm.confirmBoxButtonCancel'),
          type: 'warning',
        },
      ).then(() => {
        this.handleResetPassword({ password, userId: this.selectedUser.id });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('commons.operationCanceled'),
        });
      });
    },
    async handleResetPassword({ password, userId }) {
      try {
        this.resetingPassword = true;
        this.$mixpanel.track('Demande de nouveau mot de passe', { userId });
        await services.authService.sendResetPasswordRequest(password, userId);
        this.showResetPasswordSuccessMessage();
      } catch (e) {
        this.showErrorMessage(this.$t('commons.defaultErrorMessage'));
        console.log(e);
      }
      this.resetingPassword = false;
      this.toggleForgotPassword();
      this.resetSelectedUser();
    },
    resetUser() {
      this.selectedUser = null;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/main.styl';

.choose-users-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.shop-users-card {
  width: 90%;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow-x: hidden;
}

.shop-users-title {
  color: $primary-color;
  position: relative;
  font-size: 2.3em;
  font-weight: 600;
  display: inline;
}
.shop-users-card__login-form {
}

</style>
